import { useLocation, useNavigate } from 'react-router-dom';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function ErrorView({ message }) {
  const location = useLocation();
  const navigate = useNavigate();
  const errorMessage = location.state?.error || message || 'Ha ocurrido un error';

  const handleRetry = () => {
    navigate(-1);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <Card className="w-full max-w-md border-border/50 shadow-ambient" data-testid="error-view">
        <CardHeader>
          <div className="mb-2 flex items-center gap-3 text-destructive">
            <AlertTriangle className="h-10 w-10" />
            <CardTitle className="font-headline text-3xl tracking-tight">Error</CardTitle>
          </div>
          <CardDescription className="mt-4 text-lg">{errorMessage}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button 
            onClick={handleRetry} 
            className="w-full touch-target"
            data-testid="retry-button"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Reintentar
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}